const formatCep = (cep) => {
  if (cep) {
    return cep.replace(/(\d{5})(\d{3})/, "$1-$2");
  }
  return cep;
};

export default formatCep;
